import { getOffers, createOffer, updateOffer, deleteOffer, toggleOfferStatus } from '@lib/firestore'
import { useState, useEffect, useCallback } from 'react'

export const useOffer = (activeOnly = false) => {
  const [offers, setOffers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchOffers = useCallback(async () => {
    try {
      setLoading(true)
      const fetchedOffers = await getOffers(activeOnly)
      setOffers(fetchedOffers)
      setError(null)
    } catch (err) {
      setError('Error fetching offers')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }, [activeOnly])

  useEffect(() => {
    fetchOffers()
  }, [fetchOffers])

  const addOffer = async (offer) => {
    try {
      await createOffer(offer)
      await fetchOffers()
    } catch (err) {
      setError('Error adding offer')
      console.error(err)
    }
  }

  const editOffer = async (id, offerData) => {
    try {
      await updateOffer(id, offerData)
      await fetchOffers()
    } catch (err) {
      setError('Error updating offer')
      console.error(err)
    }
  }

  const removeOffer = async (id) => {
    try {
      await deleteOffer(id)
      await fetchOffers()
    } catch (err) {
      setError('Error deleting offer')
      console.error(err)
    }
  }

  const toggleStatus = async (id, currentStatus) => {
    try {
      await toggleOfferStatus(id, currentStatus)
      await fetchOffers()
    } catch (err) {
      setError('Error toggling offer status')
      console.error(err)
    }
  }

  return { offers, loading, error, addOffer, editOffer, removeOffer, toggleStatus }
}
